export default __webpack_public_path__ + "static/media/aframe.bd0308de.txt";